import React from 'react'
import home from "../assets/svgs/home.svg";
import message from "../assets/svgs/message.svg";
import profile from "../assets/svgs/profile.svg";
import star from "../assets/svgs/star.svg";
import settings from "../assets/svgs/settings.svg";
import help from "../assets/svgs/help.svg";
import logout from "../assets/svgs/logout.svg";
import { Link } from 'react-router-dom';


const SIdebar = () => {
  return (
    <div className='bg-main-blue grid grid-rows-[10%_45%_25%_20%]'>
        <div></div>
        <div className='grid grid-rows-5'>
            <div className='pl-7'>
                <Link to = "/dashboard"><img src = {home} alt = "" /></Link>
            </div>
            <div className='pl-7'>
            <img src = {message} alt = "" />
            </div>
            <div className='pl-7'>
            <Link to = "/user/profile"> <img src = {profile} alt = "" /></Link>
            </div>
            <div className='pl-6'>
                <img src = {star} alt = "" />
            </div>
            <div className='pl-7'>
                <img src = {settings} alt = "" />
            </div>
        </div>
        <div></div>
        <div className='grid grid-rows-3'>
            <div className='pl-7'>
                <img src = {help} alt = "" />
            </div>
            <div className='pl-7'>
                <img src = {logout} alt = "" />
            </div>
        </div>
    </div>
  )
}

export default SIdebar